/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServiceListEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const serviceListEntrypoint: EntryPoint<ServiceListEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ServiceListEntrypointComponent>(
			/* webpackChunkName: "async-servicedesk-service-list-entrypoint", jiraSpaEntry: "async-servicedesk-service-list-entrypoint" */ './ServiceListPage.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
